/**
 * @desc Guided tour
 * @example <gg-tour></gg-tour>
 */
angular.
module('gplans.dashboard').
directive('ggTour', ggTour);

function ggTour() {
  var directive = {
    templateUrl: 'templates/dashboard/gg-tour.directive.html',
    restrict: 'E',
    scope: {},
    controller: TourController,
    controllerAs: 'vm',
    bindToController: true };

  return directive;
}

TourController.$inject = ['$rootScope', '$analytics'];

function TourController($rootScope, $analytics) {
  var vm = this;
  vm.resetTour = resetTour;
  vm.stepBack = stepBack;
  vm.tourEnded = tourEnded;
  vm.tourInitialized = false;

  function resetTour() {
    slider.goToSlide(0);
    $analytics.eventTrack('Take Quick Tour');
    vm.tourInitialized = true;
    vm.currentStep = 0;
  }

  function stepBack() {
    vm.currentStep--;
  }

  function tourEnded() {
    vm.tourInitialized = false;
  }

  $rootScope.$on('ggTourStartEvent', function (event) {
    console.log(event);
    resetTour();
  });
}